import { jsx as i, jsxs as l } from "react/jsx-runtime";
import { css as n } from "../apps/ui/styled-system/css/css.js";
function d({
  baseColor: c = "transparent",
  color: o,
  padding: s,
  size: r = "medium",
  thickness: e
}) {
  s ?? (s = 1), o ?? (o = "currentColor"), r === "large" && (r = 32), r === "medium" && (r = 20), r === "small" && (r = 16), e ?? (e = r / 10);
  const t = r / 2 - s - e / 2, a = 2 * t * Math.PI;
  return /* @__PURE__ */ i(
    "div",
    {
      className: n({
        position: "relative"
      }),
      style: {
        height: r,
        width: r
      },
      children: /* @__PURE__ */ l(
        "svg",
        {
          className: n({
            inset: 0,
            position: "absolute"
          }),
          fill: "none",
          height: r,
          role: "presentation",
          width: r,
          children: [
            /* @__PURE__ */ i(
              "circle",
              {
                cx: "50%",
                cy: "50%",
                r: t,
                stroke: c,
                strokeWidth: e
              }
            ),
            /* @__PURE__ */ i(
              "g",
              {
                className: n({
                  animation: "spin 700ms linear infinite",
                  transformOrigin: "50% 50%"
                }),
                children: /* @__PURE__ */ i(
                  "circle",
                  {
                    className: n({
                      animation: "arc-pulse 1500ms infinite ease-in-out"
                    }),
                    cx: "50%",
                    cy: "50%",
                    fill: "none",
                    r: t,
                    shapeRendering: "geometricPrecision",
                    stroke: o,
                    strokeDasharray: a,
                    strokeLinecap: "round",
                    strokeWidth: e,
                    style: {
                      "--arc-offset-max": `${a * 0.3}`,
                      "--arc-offset-min": `${a * 0.4}`
                    }
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
}
export {
  d as Spinner
};
//# sourceMappingURL=Spinner.js.map
